import type { TFunction } from 'i18next';
import { formatMoneyMinor } from '@/i18n/format';

/**
 * What a wallet purchase of `amountMinor` costs, before the person confirms (TMMAPP-0119 item 9,
 * MM-D-139): "{amount} plus applicable tax". Tax is Stripe Tax's, calculated on the charge; there is
 * no estimate (it replaces MM-Q-41's tax-included preview). The charge answer's served tax shows in
 * the outcome. `null` without an amount.
 */
export function chargePreview(
  t: TFunction,
  amountMinor: number | null,
  currency: string,
  locale: string,
): string | null {
  if (amountMinor === null || amountMinor <= 0) return null;
  return t('aiWallet.chargePreview', { amount: formatMoneyMinor(amountMinor, currency, locale) });
}
